import React, { forwardRef } from 'react';

import { FlatImageEditorHandle, FlatImageEditorPendingUploadState } from '~/components/Common/Images/types';

import BaseImagesForm from './ImagesForm';

export interface RoomTypeImage {
  id: string;
  id_cloudinary_external: string;
  title?: string;
  order: number;
  hidden?: boolean;
}

interface Props {
  images: Array<RoomTypeImage>;
  onAddImage: (cloudinaryId: string, filename: string) => Promise<RoomTypeImage>;
  onDeleteImage?: (imageId: string | number) => Promise<void> | void;
  onUpdateImages: (images: Array<RoomTypeImage>) => Promise<void> | void;
  enablePendingCropUpload?: boolean;
  hasHiddenToggle?: boolean;
  hideDeleteButton?: boolean;
  onPendingUploadStateChange?: (state: FlatImageEditorPendingUploadState) => void;
}

const RoomTypeImagesForm = forwardRef<FlatImageEditorHandle, Props>(function RoomTypeImagesForm(props, ref) {
  const {
    hasHiddenToggle,
    hideDeleteButton,
    images,
    onAddImage,
    onDeleteImage,
    onPendingUploadStateChange,
    onUpdateImages,
    enablePendingCropUpload = false,
  } = props;

  return (
    <BaseImagesForm
      ref={ref}
      enablePendingCropUpload={enablePendingCropUpload}
      hasHiddenToggle={hasHiddenToggle}
      hideDeleteButton={hideDeleteButton}
      images={images}
      onAddImage={onAddImage}
      onDeleteImage={onDeleteImage}
      onPendingUploadStateChange={onPendingUploadStateChange}
      onUpdateImages={(nextImages) => Promise.resolve(onUpdateImages(nextImages as Array<RoomTypeImage>))}
      showSaveButton={false}
    />
  );
});

RoomTypeImagesForm.displayName = 'RoomTypeImagesForm';

export default RoomTypeImagesForm;
